<template>
    <flex-element :element-type="elementType" class="e-video f-relative" :class="htmlClass">
        <div data-video-wrapper v-html="richText" />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';

export default {
    name: 'a-video',
    mixins: [baseAtom],

    props: {
        richText: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.e-video {
    iframe,
    object,
    embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
